'use strict';
import ChannelApi from '../scripts/api/channel.api'
import config from '../scripts/config';

export class User {
  constructor(data){
    this.username =''
    this.firstname =''
    this.name =''
    this.org_name =''
    this.email =''
    this.image_doc = null
    this.status_mode = 'offline'
    this.status = ''
    this.default_image = true;
    this.user_ids = []
    this.user_id = null
    this.folder_rights = []
    this.public = false
    this.chat_visuals = {
        sidebar_collapsed : true,
        language : 'en',
        active_channel_id: ''
    }
    this.emails_settings = {
        "mentions": true,
        "public_contact": true,
        "unread_messages": true,
        "joined_channel": true,
        "left_channel": true,
    }
    this.settings = {
        'page_after_login' : 'webaccess',
        'show_preview_message' : true,
        'enable_instant_messaging_notification' : true,
    }
    this.image_db = {}
    this.image_doc = config.DEFAULT_USER_IMAGE
    this.empty = true
    if(data != null){
        this.empty = false
        if(data.user_id){
            this.user_id = data.user_id
        }

        if((typeof data.username != 'undefined' && data.username.length > 0 )){
            this.username = data.username
        }

        // else if(data.username.length == 0 && data.user_id != UserSessionManager.GetLoggedInUserId()){
        //     this.username = data.email.slice(0, data.email.indexOf('@'))
        // }
        // else {
        //     this.username = data.email.slice(0, data.email.indexOf('@'))
        // }

        if(typeof data.email !='undefined' && data.email){
            this.email = data.email
        }

        if(typeof data.public !='undefined'){
            this.public = data.public
        }

        if(typeof data.org_name !='undefined' &&  data.org_name){
            this.org_name = data.org_name
        }
        if(typeof data.name !='undefined' && data.name.length > 0){
            this.name = data.name
        }else {
            this.name = data.email
        }

        if(typeof data.firstname !='undefined' && data.firstname){
            this.firstname = data.firstname
        }
        if(typeof data.reachability !='undefined' && data.reachability){
            this.reachability = data.reachability
        }else {
          this.reachability = 'offline'
        }
        if(data.image_doc != null && typeof data.image_doc.valueb64 != 'undefined'){
            this.image_db = data.image_doc
            this.image_doc = "data"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
            if(data.image_doc.mimetype.indexOf(":")== -1){
                this.image_doc = "data:"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
            }
            this.default_image = false
        }
        if(data.chat_visuals){
            this.chat_visuals = data.chat_visuals
            if(typeof this.chat_visuals.language == "undefined" || this.chat_visuals.language == ''){
                this.chat_visuals.language = config.loggedInUserLanguage
            }
        }

        if(data.status_mode){
            if(config.USER_REACHABILITY_STATUS.indexOf(data.status_mode) < 0){
                this.status_mode = data.reachability
            } else {
                this.status_mode = data.status_mode
            }
        }

        if(data.user_ids){
            this.user_ids = data.user_ids
        }

        if(typeof data.emails_settings != 'undefined'){
            this.emails_settings = data.emails_settings
        }

        if(typeof data.cpadmin != 'undefined'){
            this.cpadmin = data.cpadmin
        }

        if (data.hasOwnProperty('settings')) {
            this.settings.page_after_login = data.settings.hasOwnProperty('page_after_login') ? data.settings.page_after_login : this.settings.page_after_login;
            this.settings.show_preview_message = data.settings.hasOwnProperty('show_preview_message') ? data.settings.show_preview_message : this.settings.show_preview_message;
            this.settings.enable_instant_messaging_notification = data.settings.hasOwnProperty('enable_instant_messaging_notification') ? data.settings.enable_instant_messaging_notification : this.settings.enable_instant_messaging_notification;
        }
    }
  }

  isEmpty() {
      return this.empty;
  }

  static getMyChannels(){
    return ChannelApi.getMyChannels()
  }

//   static setProfileImage(image_doc){
//     this.image_db = image_doc
//     this.image_doc = "data"+image_doc.mimetype+";base64," + image_doc.valueb64
//     if(image_doc.mimetype.indexOf(":")== -1){
//         this.image_doc = "data:"+image_doc.mimetype+";base64," + image_doc.valueb64
//     }
//   }

  DirectMessage(id){
    this.direct_channel = id
  }
}
